import React, { useContext, JSX } from "react";
import AppContext from "context/app";
import { useTranslation } from "react-i18next";

import { GenericFieldProps, GenericField } from "./fieldProps";
import { CustomCreatable } from "./creatable";
import { getTextFromMultiLang } from "helpers/multiLang";
import { ReferenceRole } from "generated/graphql";

type ReferenceRolesType = ReferenceRole[];
type ReferenceRoleFieldProps = GenericFieldProps<ReferenceRolesType>;

const ReferenceRolesField = ({
  value,
  onChange,
  disabled,
  language,
}: ReferenceRoleFieldProps): JSX.Element => {
  const { catalogues } = useContext(AppContext);
  const { i18n } = useTranslation();
  const m = getTextFromMultiLang(language ?? "de");

  const allRoles = catalogues?.referenceRoles
    ?.map((role: any) => ({
      label: m(role?.name, "").trim(),
      value: `${role.id}`,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div className="text-sm">
      <CustomCreatable
        disabled={disabled}
        onChange={onChange}
        options={allRoles}
        value={value}
        idValue="referenceRoleId"
        currentLanguage={i18n.language}
      />
    </div>
  );
};

export const referenceRolesField: GenericField<ReferenceRolesType> = {
  renderer: ReferenceRolesField,
  onBeforeSave: (value: ReferenceRolesType) =>
    value
      ?.map((v) => ({
        referenceRoleId: v.referenceRoleId,
        newText: v.newText,
        sourceLanguage: v.sourceLanguage || "de",
      }))
      .filter(
        (v) =>
          (v.referenceRoleId ? +v.referenceRoleId : 0) > 0 ||
          (v.newText?.length ?? 0) > 0,
      ),
  equals: (a: ReferenceRolesType, b: ReferenceRolesType) => {
    return (
      (a?.map((v) => `${v.referenceRoleId}-${v.newText ?? ""}`).join(",") ??
        "") ===
      (b?.map((v) => `${v.referenceRoleId}-${v.newText ?? ""}`).join(",") ?? "")
    );
  },
};
